var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('MainMenu',{staticClass:"side-menu-left",attrs:{"selectTab":_vm.selectTab,"admin_fit20":this._data,"fit20":_vm.fit20}}),_c('Content',{staticClass:"content",attrs:{"fit20":_vm.fit20,"selectTab":_vm.selectTab,"admin_fit20":this._data,"saveBlock":_vm.saveBlock,"cancelEditing":_vm.cancelEditing}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }